<template>
  <PostcodeInput
    v-model="postcodeInput"
    v-on-clickaway="handleBlur"
    :fixed="fixed"
    :container="container"
    :status="status"
    :has-error="error"
    :focus-key="focusKey"
    :is-mobile="isMobile"
    :is-tablet="isTablet"
    :is-homepage="isHomepage"
    :button-label="submitButtonLabel"
    :post-code-btn-theme="postCodeBtnTheme"
    :show-search-icon="showSearchIcon"
    :icon="icon"
    :icon-hover="iconHover"
    :use-location-pin-icon="useLocationPinIcon"
    :location-pin-icon-color="locationPinIconColor"
    :postcode-success-icon="postcodeSuccessIcon"
    :color-theme="colorTheme"
    @submit="fetchPostcode"
    @edit="handleEdit"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import PostcodeInput from './PostcodeInput'
import InputRegexes from '../mixins/InputRegexes'
import Routable from '../mixins/Routable'

export default {
  name: 'SmartPostcodeInput',

  components: { PostcodeInput },

  mixins: [InputRegexes, Routable, clickaway],

  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    container: {
      type: Boolean,
      default: false
    },
    isHomepage: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: 'Start quote'
    },
    showSearchIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconHover: {
      type: String,
      default: null
    },
    useLocationPinIcon: {
      type: Boolean,
      default: true
    },
    locationPinIconColor: {
      type: String,
      default: '#032942'
    },
    postcodeSuccessIcon: {
      type: String,
      default: 'check-circle.svg'
    },
    postCodeBtnTheme: {
      type: String,
      default: ''
    },
    colorTheme: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      error: false,
      focusKey: false
    }
  },

  computed: {
    ...mapGetters(['isMobile', 'isTablet']),

    postcodeInput: {
      get () {
        return this.$store.getters.getPostcodeInput
      },
      set (value) {
        this.$store.commit('UPDATE_POSTCODE_INPUT', value)
      }
    },
    status () {
      return this.$store.state.AddressLookup.status
    },

    submitButtonLabel () {
      return this.onPage('home') ? this.buttonLabel : 'Find business'
    }
  },

  created () {
    if (this.$route.path === '/') this.$store.commit('LOAD_ADDRESSES_READY')
  },

  methods: {
    fetchPostcode () {
      window.dataLayer.push({
        'event': 'button',
        'button': {
          'class': 'postcode-address-search',
          'id': 'postcode-find-business-search',
          'name': 'find-business-search',
          'text': this.submitButtonLabel,
          'type': 'submit'
        }
      })

      this.error = false

      if (!this.postcodeInput.match(this.postcodeRegex)) {
        this.error = true
        return
      }

      this.$store
        .dispatch('actionLoadAddresses', this.postcodeInput)
        .then(() => this.$emit('submit'))
        .catch(() => this.$emit('submit'))
    },

    handleEdit () {
      this.$store.commit('LOAD_ADDRESSES_READY')
      this.$nextTick(() => this.focusInput())
    },

    focusInput () {
      this.focusKey = !this.focusKey
    },

    handleBlur () {
      this.error = false
    }
  }
}
</script>
